"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Banner_1 = __importDefault(require("../Banner"));
var BlockWithTimer_1 = __importDefault(require("../BlockWithTimer"));
var TableWithResults_1 = __importDefault(require("../TableWithResults"));
var navigation_1 = require("next/navigation");
var swr_hooks_1 = require("@l2p/swr-hooks");
var tournament_api_1 = require("@l2p/tournament-api");
var ui_components_1 = require("@l2p/ui-components");
var apps_shared_1 = require("@l2p/apps-shared");
var common_components_1 = require("@l2p/common-components");
var next_intl_1 = require("next-intl");
var FullTournamentInfoClassic = function (_a) {
    var _b, _c, _d, _e;
    var tournamentSlug = _a.tournamentSlug, banner = _a.banner, bannerMobile = _a.bannerMobile, gameCardPlaceholder = _a.gameCardPlaceholder;
    var t = (0, next_intl_1.useTranslations)('translation');
    var router = (0, navigation_1.useRouter)();
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var _f = (0, swr_hooks_1.useGamesByCategories)(), dataCategories = _f.data, isLoadingCategories = _f.isLoading;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var _g = (0, swr_hooks_1.useCurrentTournament)({
        slug: tournamentSlug,
        status: tournament_api_1.TournamentStatusEnum.Active,
    }), data = _g.data, isLoading = _g.isLoading;
    (0, react_1.useEffect)(function () {
        if (!data && !isLoading) {
            router.push('/not_found');
        }
    }, [data, isLoading, router]);
    if (isLoading || isLoadingCategories)
        return react_1.default.createElement(ui_components_1.PageLoading, { imageUrl: "/img/bc_preloader.gif" });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        Object.keys(breakpoints).length > 0 && (react_1.default.createElement(Banner_1.default, { title: translateLocale((_b = data === null || data === void 0 ? void 0 : data.baseTournament) === null || _b === void 0 ? void 0 : _b.name), description: translateLocale((_d = (_c = data === null || data === void 0 ? void 0 : data.baseTournament) === null || _c === void 0 ? void 0 : _c.descriptions) === null || _d === void 0 ? void 0 : _d.short), withLaurel: true, background: breakpoints.mobile ? bannerMobile : banner })),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
            (data === null || data === void 0 ? void 0 : data.endDate) && (react_1.default.createElement(BlockWithTimer_1.default, { id: data.id, userConfirmed: !!((data === null || data === void 0 ? void 0 : data.id) && (data === null || data === void 0 ? void 0 : data.me)), endAt: String(new Date(data.endDate)) })),
            react_1.default.createElement(TableWithResults_1.default, { tournament: data }),
            react_1.default.createElement(common_components_1.GamesWithSearchAndPagination, { title: t('gamesInTournament'), gameCardPlaceholder: gameCardPlaceholder, categoryId: (_e = dataCategories === null || dataCategories === void 0 ? void 0 : dataCategories[apps_shared_1.Categories.NOT_LIVE]) === null || _e === void 0 ? void 0 : _e.id, place: "tournament" }))));
};
exports.default = FullTournamentInfoClassic;
